/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import React, { styled } from 'fierry/react.old';


const getBorderDashoffset = ({ borderGeometry }) =>
{
  const currentLength = borderGeometry.getBorderPartitionLengths(borderGeometry.getCurrent())[0];
  const externalLength = borderGeometry.getBorderPartitionLengths(borderGeometry.getExternal())[0];

  return externalLength - currentLength;
};


const ExternalBorder = styled.path`

  ${props => props.externalStyle}

  stroke-dashoffset: ${props => getBorderDashoffset(props)};
  stroke-linecap: round;
`;


const SectorBorder = styled.path`

  ${props => props.sectorStyle}

  stroke-dashoffset: ${props => getBorderDashoffset(props)};
  stroke-linecap: round;
`;


const ZoneBorder = styled.path`

  ${props => props.zoneStyle}

  stroke-dashoffset: ${props => getBorderDashoffset(props)};
  stroke-linecap: round;
`;


const getPath = (borderGeometry) =>
{
  const [lhs, rhs] = borderGeometry.getBorderPoints();

  return `M ${lhs.x},${lhs.y} L ${rhs.x},${rhs.y}`;
}


const getBorderProps = (hexGeometry, borderGeometry) =>
{
  return { d: getPath(borderGeometry), key: borderGeometry.getIndex(), hexGeometry, borderGeometry };
};


export default ({ location, geometry, ...props }) =>
{
  const hexGeometry = geometry.getHex();
  const serverBorders = location.getObject().getBorders();

  return geometry.getZone(location).getBorders().map(borderGeometry =>
  {
    const neighbor = borderGeometry.getNeighbor().getLocation();

    if (serverBorders.isExternalBorder(neighbor))
    {
      return <ExternalBorder {...props} {...getBorderProps(hexGeometry, borderGeometry)} />;
    }

    if (geometry.getHex().isSectorVisible() && serverBorders.isGroupBorder(neighbor))
    {
      return <SectorBorder {...props} {...getBorderProps(hexGeometry, borderGeometry)} />;
    }

    if (geometry.getHex().isZoneVisible())
    {
      return <ZoneBorder {...props} {...getBorderProps(hexGeometry, borderGeometry)} />;
    }

    return null;
  });
}
